import { render, staticRenderFns } from "./sentenceSourceSymbol.vue?vue&type=template&id=3d9aa0c8"
import script from "./sentenceSourceSymbol.vue?vue&type=script&lang=js"
export * from "./sentenceSourceSymbol.vue?vue&type=script&lang=js"
import style0 from "./sentenceSourceSymbol.vue?vue&type=style&index=0&id=3d9aa0c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports